import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import { TagDot } from '@components/TagChip';

const ChipBase = styled(Chip, {
    shouldForwardProp: prop => prop !== 'bg' && prop !== 'fg',
})(({ bg, fg }) => ({
    backgroundColor: bg,
    color: fg,
    height: 24,
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 12,
    '& .MuiChip-label': {
        padding: '0 10px 0 6px',
    },
    '& .MuiChip-icon': {
        marginLeft: 8,
        marginRight: 0,
    },
}));

// Single source of truth for status chip colors. Tinted background + darker
// foreground for legibility. Consumers map their domain (sync badge, review
// status, etc.) to one of these tones.
export const STATUS_PALETTE = {
    success: { bg: '#E5F5EC', fg: '#0B8D00' },
    warning: { bg: '#FFEFDF', fg: '#ED6C02' },
    danger: { bg: '#FFE3E1', fg: '#B00020' },
    info: { bg: '#E3F0FB', fg: '#1976D2' },
    neutral: { bg: '#F0F0F0', fg: '#5F6368' },
};

const StatusChip = ({ bg, fg, label, ...rest }) => (
    <ChipBase size="small" bg={bg} fg={fg} icon={<TagDot color={fg} />} label={label} {...rest} />
);

export default StatusChip;
